export class RouteNames {
  static ClassSetup = "ClassSetUp";
  static TeacherClass = "TeacherClass";
  static StudentClass = "StudentClass";
}
